import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { putSicuro } from '../services/offline';

export const CAMPI_IMPIANTO = {
  estintori: [
    {k:'numero', l:'N°'}, {k:'tipo', l:'Tipo'}, {k:'matricola', l:'Matricola'},
    {k:'kg', l:'Kg'}, {k:'luogo', l:'Ubicazione'},
    {k:'anno_produzione', l:'Anno produzione', t:'number'},
    {k:'anno_revisione', l:'Anno revisione', t:'number'},
    {k:'anno_collaudo', l:'Anno collaudo', t:'number'},
    {k:'data_scadenza', l:'Scadenza', t:'date'},
    {k:'palazzo_scala', l:'Palazzo/Scala'}, {k:'piano', l:'Piano'},
    {k:'anno_costruzione', l:'Anno', t:'number'},
    {k:'note', l:'Note'},
  ],
  idranti: [
    {k:'numero', l:'N°'}, {k:'tipo', l:'Tipo'}, {k:'luogo', l:'Ubicazione'},
    {k:'anno_costruzione', l:'Anno', t:'number'},
    {k:'data_scadenza', l:'Scadenza', t:'date'}, {k:'note', l:'Note'},
  ],
  porte: [
    {k:'numero', l:'N°'}, {k:'tipo', l:'Tipo'}, {k:'fabbricante', l:'Fabbricante'},
    {k:'ante', l:'Ante'}, {k:'matricola', l:'Matricola'},
    {k:'luogo', l:'Ubicazione'}, {k:'piano', l:'Piano'},
    {k:'data_scadenza', l:'Scadenza', t:'date'}, {k:'note', l:'Note'},
  ],
  cassette_mediche: [
    {k:'tipo', l:'Tipo'}, {k:'data_scadenza', l:'Scadenza', t:'date'},
    {k:'scadenza_anno', l:'Anno scadenza', t:'number'},
  ],
};

export const IMPIANTI_LABEL_MODALE = {
  estintori:'Estintore', idranti:'Idrante', porte:'Porta REI',
  cassette_mediche:'Cassetta medica',
};

export default function ModaleImpianto({ tipo, impianto, impiantoId, clienteId, onClose, onSaved }) {
  const campi = CAMPI_IMPIANTO[tipo] || [];
  const isNuovo = !impianto && !impiantoId;
  const [form, setForm]     = useState({});
  const [saving, setSaving] = useState(false);
  const [loading, setLoad]  = useState(false);
  const [err, setErr]       = useState('');
  const [idReale, setId]    = useState(impianto?.id ?? impiantoId ?? null);
  const [tsLetto, setTsLetto] = useState(impianto?.updated_at ?? null);
  const [conflitto, setConflitto] = useState(null);
  const [accodato, setAccodato] = useState(false);

  const riempi = (src) => {
    const f = {};
    campi.forEach(c => {
      let v = src?.[c.k];
      if (c.t === 'date' && v) v = String(v).substring(0,10);
      f[c.k] = v ?? '';
    });
    setForm(f);
  };

  useEffect(() => {
    // Dal dettaglio cliente arriva il record intero; dalla checklist solo l'id,
    // quindi in quel caso lo carichiamo dal server.
    if (impianto) { riempi(impianto); return; }
    if (!impiantoId) { riempi(null); return; }
    setLoad(true);
    api.get(`/impianto/${tipo}/${impiantoId}`)
      .then(r => { const d = r.data?.data ?? r.data; setId(d?.id ?? impiantoId); setTsLetto(d?.updated_at ?? null); riempi(d); })
      .catch(e => setErr(e.response?.data?.error || 'Impossibile caricare i dati.'))
      .finally(() => setLoad(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo, impiantoId, impianto]);

  const salva = async () => {
    setSaving(true); setErr('');
    try {
      const payload = {};
      campi.forEach(c => {
        let v = form[c.k];
        if (v === '') v = null;
        else if (c.t === 'number' && v != null) v = parseInt(v) || null;
        payload[c.k] = v;
      });
      if (isNuovo) {
        payload.cliente_id = parseInt(clienteId);
        await api.post(`/impianto/${tipo}`, payload);
        onSaved();
        return;
      }

      // il timestamp letto all'apertura permette al server di rilevare conflitti
      if (tsLetto) payload._updated_at = tsLetto;

      const esito = await putSicuro(`/impianto/${tipo}/${idReale}`, payload);
      if (esito.accodato) {
        setAccodato(true);
        return;   // resta aperta per mostrare l'avviso
      }
      onSaved();
    } catch(e) {
      if (e.response?.status === 409) {
        setConflitto(e.response.data?.attuale || {});
        setErr('');
      } else {
        setErr(e.response?.data?.error || e.message);
      }
    } finally { setSaving(false); }
  };

  const sovrascrivi = async () => {
    setSaving(true); setConflitto(null);
    try {
      const payload = {};
      campi.forEach(c => {
        let v = form[c.k];
        if (v === '') v = null;
        else if (c.t === 'number' && v != null) v = parseInt(v) || null;
        payload[c.k] = v;
      });
      const esito = await putSicuro(`/impianto/${tipo}/${idReale}`, payload);
      if (esito.accodato) { setAccodato(true); return; }
      onSaved();
    } catch(e) {
      setErr(e.response?.data?.error || e.message);
    } finally { setSaving(false); }
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',
      alignItems:'center',justifyContent:'center',zIndex:1000,padding:20}}
      onClick={onClose}>
      <div style={{background:'#fff',borderRadius:12,padding:24,width:'100%',
        maxWidth:480,maxHeight:'90vh',overflowY:'auto'}}
        onClick={e=>e.stopPropagation()}>
        <h3 style={{margin:'0 0 16px',fontSize:16}}>
          {isNuovo ? '➕ Nuovo' : '✏️ Modifica'} {IMPIANTI_LABEL_MODALE[tipo]||tipo}
        </h3>

        {campi.length === 0 ? (
          <div style={{color:'#6b7280',fontSize:13,padding:'12px 0'}}>
            La modifica per questo tipo di impianto non è ancora disponibile.
            Puoi intervenire dal dettaglio cliente.
          </div>
        ) : loading ? (
          <div style={{color:'#6b7280',fontSize:13,padding:'12px 0'}}>Caricamento…</div>
        ) : (
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
            {campi.map(c => (
              <div key={c.k} style={{gridColumn: c.k==='note'||c.k==='luogo' ? '1/-1' : 'auto'}}>
                <label className="form-label">{c.l}</label>
                <input type={c.t||'text'} className="form-control" value={form[c.k]||''}
                  onChange={e=>setForm(f=>({...f,[c.k]:e.target.value}))} />
              </div>
            ))}
          </div>
        )}

        {accodato && (
          <div style={{background:'#fef9c3',color:'#854d0e',padding:10,borderRadius:6,
                       marginTop:12,fontSize:13}}>
            📴 <strong>Modifica in attesa</strong><br/>
            Nessuna connessione: la modifica è salvata sul dispositivo e verrà inviata
            appena torna la rete. Non chiudere l'app prima di aver ripreso il segnale.
          </div>
        )}

        {conflitto && (
          <div style={{background:'#fee2e2',color:'#991b1b',padding:10,borderRadius:6,
                       marginTop:12,fontSize:13}}>
            ⚠️ <strong>Modificato da un altro utente</strong><br/>
            Sul server risulta: {campi.slice(0,4).map(c =>
              `${c.l}: ${conflitto[c.k] ?? '—'}`).join(' · ')}
            <div style={{display:'flex',gap:8,marginTop:10}}>
              <button className="btn btn-secondary" style={{flex:1}}
                onClick={()=>{ riempi(conflitto); setTsLetto(conflitto.updated_at || null); setConflitto(null); }}>
                Usa i dati del server
              </button>
              <button className="btn btn-primary" style={{flex:1}} onClick={sovrascrivi}>
                Sovrascrivi comunque
              </button>
            </div>
          </div>
        )}

        {err && <div style={{color:'#dc2626',fontSize:12,marginTop:10}}>⚠️ {err}</div>}

        <div style={{display:'flex',gap:8,marginTop:16}}>
          <button className="btn btn-secondary" style={{flex:1}} onClick={onClose}>
            {campi.length === 0 ? 'Chiudi' : 'Annulla'}
          </button>
          {campi.length > 0 && (
            <button className="btn btn-primary" style={{flex:1}} onClick={salva}
              disabled={saving || loading}>
              {saving ? '...' : '💾 Salva'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
